import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { CreateUserAccountActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class CreateUserAccountEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getCreateUserAccount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CreateUserAccountActions.getCreateUserAccount),
      switchMap((action) =>
        this.onboardingProductsService.getCreateUserAccount(action.request).pipe(
          map((res) => this.common.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
            CreateUserAccountActions.getCreateUserAccountSucess({ response: res })
          ),
          catchError((error) =>
            of(
              CreateUserAccountActions.getCreateUserAccountError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );
}
